export default "__VITE_ASSET__39783fd5__"